import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="final-cta" ref={ref} className="w-full bg-gradient-to-b from-bg-secondary to-bg-primary py-20 px-4 sm:px-6 lg:px-8" data-id="element-42">
      <div className="max-w-4xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-accent-bronze/20 via-bg-secondary to-bg-secondary border-2 border-accent-bronze rounded-sm p-8 sm:p-12 text-center" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="inline-flex items-center justify-center w-20 h-20 bg-accent-bronze/20 rounded-full mb-6" data-id="element-45">
            <ShieldCheckIcon className="w-10 h-10 text-accent-bronze" data-id="element-46" />
          </motion.div>

          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-text-primary mb-6" data-id="element-47">
            Sentadilla o Dependencia
          </h2>

          <p className="text-xl sm:text-2xl text-text-secondary mb-8 font-body leading-relaxed max-w-2xl mx-auto" data-id="element-48">
            La elección que estás tomando cada mañana. Tu futuro depende de la
            carga que seas capaz de levantar hoy.
          </p>

          <div className="mb-8" data-id="element-49">
            <p className="text-lg text-text-secondary font-body mb-2" data-id="element-50">
              No es tu edad, es tu falta de carga.
            </p>
            <p className="text-lg text-accent-bronze font-body font-semibold" data-id="element-51">
              Y tiene solución.
            </p>
          </div>

          <CTAButton size="large" onClick={() => {
          trackAddToCart();
          window.location.href = 'https://www.consejossimples.com/cart/53406630216013:1';
        }} data-id="element-52">
            Blindar Mi Estructura Ahora
          </CTAButton>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-text-muted text-sm font-body" data-id="element-53">
            <div className="flex items-center gap-2" data-id="element-54">
              <ShieldCheckIcon className="w-4 h-4 text-accent-bronze" data-id="element-55" />
              <span data-id="element-56">Garantía 30 días</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-text-muted rounded-full" data-id="element-57" />
            <div className="flex items-center gap-2" data-id="element-58">
              <ShieldCheckIcon className="w-4 h-4 text-accent-bronze" data-id="element-59" />
              <span data-id="element-60">Acceso inmediato</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-text-muted rounded-full" data-id="element-61" />
            <div className="flex items-center gap-2" data-id="element-62">
              <ShieldCheckIcon className="w-4 h-4 text-accent-bronze" data-id="element-63" />
              <span data-id="element-64">Pago único</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-65">
          <p className="text-text-muted font-body text-sm" data-id="element-66">
            © 2024 Código Longevidad. Todos los derechos reservados.
          </p>
        </motion.div>
      </div>
    </section>;
}